import { memo, useEffect } from 'react';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import ActionsPanel from 'components/Patients/Details/ActionsPanel/ActionsPanel';
import FilePreview from 'components/Dialogs/FilePreview/FilePreview';
import Messages from 'components/Messages/Messages';
import usePatients from 'hooks/usePatients';

const Conversation = () => {
  const { clearLocalActivePatient } = usePatients();

  useEffect(() => {
    return clearLocalActivePatient;
  }, [clearLocalActivePatient]);

  return (
    <>
      <FilePreview />
      <Messages />
      <ActionsPanel />
    </>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Conversation {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);